/*!-----------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.39.0-dev.20230601(c84c0cb8f9a7a00a4b391a89d6383aa04d9a89e2)
 * Released under the MIT license
 * https://github.com/microsoft/vscode/blob/main/LICENSE.txt
 *-----------------------------------------------------------*/

define("vs/base/common/worker/simpleWorker.nls.de", {
	"vs/base/common/platform": [
		"_",
	]
});